import React from 'react';
import { useKambiError } from '../../hooks/use-kambi-error';
import './styles.scss';

export const ErrorOverlay = () => {
  const isKambiError = useKambiError();

  if (!isKambiError) {
    return null;
  }

  return (
    <div className="book-kambi-error-overlay">
      <h1>Esta demorando en mas de lo esperado.</h1>
      <button className="btn-pick btn btn-sm btn-default" onClick={() => window.location.reload()}>
        Reintentar
      </button>
    </div>
  );
};
